/* PIOLET WhatsApp lead attribution (phase 1-2).
   1) On landing, keeps first-touch gclid/gbraid/wbraid/fbclid/UTM for 90 days.
   2) On any WhatsApp link click, appends a short code like "[G-POLAR-PRO #k3x9q2ab]"
      to the prefilled text and beacons the click ids to the bot under that token.
      One visitor token lives in piolet_wa_token_v1 for 90 days and is reused.
      The beacon also sends fbc and fbp. */
(function () {
  if (window.__pioletWaAttr) return; window.__pioletWaAttr = 1;
  var KEY = 'piolet_attr_v1', TOKEN_KEY = 'piolet_wa_token_v1', DAYS = 90, BEACON = 'https://bot.thepiolet.com/track/wa-click';
  var FIELDS = ['gclid','gbraid','wbraid','fbclid','utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbc','fbp'];
  function load() { try { var d = JSON.parse(localStorage.getItem(KEY) || 'null'); if (d && Date.now() - d.ts < DAYS * 864e5) return d; } catch (e) {} return null; }
  function save(d) { try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {} }
  function readCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }
  var q = new URLSearchParams(location.search), fresh = {}, has = false;
  FIELDS.forEach(function (k) { var v = q.get(k); if (v) { fresh[k] = v.slice(0, 300); has = true; } });
  var attr = load();
  if (has && (!attr || fresh.gclid || fresh.gbraid || fresh.wbraid || fresh.fbclid)) { fresh.ts = Date.now(); fresh.page = location.pathname; attr = fresh; save(attr); }
  attr = attr || {};
  function prefix() {
    var s = (attr.utm_source || '').toLowerCase();
    if (attr.gclid || attr.gbraid || attr.wbraid || s === 'google') return 'G';
    if (attr.fbclid || /^(facebook|fb|instagram|ig|meta)$/.test(s)) return 'M';
    if (/klaviyo|email/.test(s)) return 'E';
    return 'S';
  }
  function place(el) {
    var custom = el && el.closest && el.closest('[data-wa-ref]');
    if (custom) return custom.getAttribute('data-wa-ref');
    var p = location.pathname.replace(/^\/en(\/|$)/, '/');
    var m = p.match(/\/products\/([^\/?#]+)/); if (m) return m[1];
    if (/\/collections\//.test(p)) return 'COL';
    if (/\/pages\//.test(p)) return 'PAGE';
    return p === '/' ? 'HOME' : 'WEB';
  }
  function token() {
    var now = Date.now();
    try {
      var d = JSON.parse(localStorage.getItem(TOKEN_KEY) || 'null');
      if (d && typeof d.t === 'string' && /^[a-z0-9]{8}$/.test(d.t) && (now - d.ts) < DAYS * 864e5) return d.t;
    } catch (e) {}
    var alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789', t = '';
    for (var i = 0; i < 8; i++) t += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
    try { localStorage.setItem(TOKEN_KEY, JSON.stringify({ t: t, ts: now })); } catch (e2) {}
    return t;
  }
  function isWa(u) { return /^(https?:)?\/\/(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\//i.test(u || ''); }
  function tag(u, el) {
    try {
      var url = new URL(u, location.href);
      var text = url.searchParams.get('text') || 'Hola, quiero información';
      if (/\[[A-Z]{1,3}-[A-Z0-9-]+( #[a-z0-9]+)?\]/i.test(text)) return u;
      var t = token();
      var code = (prefix() + '-' + place(el)).toUpperCase().replace(/[^A-Z0-9-]/g, '-').replace(/-+/g, '-').slice(0, 30);
      url.searchParams.set('text', text + ' [' + code + ' #' + t + ']');
      var body = { t: t, ref: code, page: location.pathname };
      var snap = {};
      FIELDS.forEach(function (k) { if (attr[k]) snap[k] = attr[k]; });
      var cookieFbc = readCookie('_fbc');
      var cookieFbp = readCookie('_fbp');
      if (cookieFbc) snap.fbc = cookieFbc.slice(0, 300);
      if (cookieFbp) snap.fbp = cookieFbp.slice(0, 300);
      if (!snap.fbc) {
        var fbclid = snap.fbclid || '';
        if (!fbclid) { try { fbclid = new URLSearchParams(location.search).get('fbclid') || ''; } catch (eFb) {} }
        if (fbclid) snap.fbc = ('fb.1.' + Date.now() + '.' + fbclid).slice(0, 300);
      }
      FIELDS.forEach(function (k) { if (snap[k]) body[k] = snap[k]; });
      try { navigator.sendBeacon(BEACON, new Blob([JSON.stringify(body)], { type: 'text/plain' })); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'whatsapp_click', wa_ref: code }); } catch (e) {}
      return url.toString();
    } catch (e) { return u; }
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest && ev.target.closest('a[href]');
    if (a && isWa(a.getAttribute('href'))) a.setAttribute('href', tag(a.getAttribute('href'), a));
  }, true);
  var aclick = HTMLAnchorElement.prototype.click;
  HTMLAnchorElement.prototype.click = function () { if (isWa(this.getAttribute('href'))) this.setAttribute('href', tag(this.getAttribute('href'), document.activeElement)); return aclick.apply(this, arguments); };
  var open = window.open;
  window.open = function (u) { var args = Array.prototype.slice.call(arguments); if (isWa(String(u))) args[0] = tag(String(u), document.activeElement); return open.apply(window, args); };
})();
